// extracted by mini-css-extract-plugin
export default {"tag":"styles-module__[local]___iNH8w","tagGroup":"styles-module__[local]___OJIvI"};